import historyContext from '../contexts/history-context';

export interface URLparams {
  query?: string;
  filters?: string[];
  'dealer-id'?: string;
  'geolocation-lat'?: number;
  'geolocation-lng'?: number;
  'triggered-by-teaser'?: boolean | string;
  selected?: string;
  country?: string;
  favorite?: string;
  radius?: string;
}

export function useURLService() {
  const { historyService } = historyContext.useHistoryState();

  function generateUrl(appURL: string, params: URLparams, key?: string) {
    let p: keyof URLparams;
    for (p in params) {
      const value = params[p];
      if (!value || !value.toString().length) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete params[p];
      }
    }
    const searchParams = new URLSearchParams(params as URLSearchParams);

    const historyServiceUrl = historyService
      ? historyService.createNewRootLocationForMultipleConsumers({
          historyKey: key || historyService.historyKey,
          location: { search: searchParams.toString() },
        })
      : null;

    const url = new URL(
      historyServiceUrl ? `${historyServiceUrl.search}${historyServiceUrl.hash}` : '',
      appURL,
    );
    return url;
  }

  return generateUrl;
}
